/**
 * @format
 * @description Superhero ad sizes: displayed for Anonymous readers
 */
export default {
  // available-slots-for-tier: {
  //   ldbd: [],
  //   flex: [],
  // },
  mobile: {
    flex: [[320, 450]]
  },
  portrait: {
    ldbd: [[768, 450]]
  },
  landscape: {
    ldbd: [[1024, 450]]
  },
  desktop: {
    ldbd: [[1800, 450]]
  }
};
